import React from "react";
const Error404 = () => (
  <div className="Error404">
    <h1>Error 404</h1>
    <h1>Page Not Found</h1>
  </div>
);
export default Error404;
